<template>
  <slide-modal
    v-show="true"
    @close-modal="$emit('close-modal')"
  >
    <template v-slot:header>
      <!-- <div style="width:100%;text-align:center"> -->
      <!-- <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;"> -->
      <div style="flex:1;display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
        <div><b-button variant="light" style="background:transparent;border:none;color:white" @click="$emit('close-modal')"><font-awesome-icon :icon="['far', 'times']" style="font-size:28px" /></b-button></div>
        <!-- <div /> -->
        <img src="../assets/images/listolinks_w.png"  style="width:200px;" />
        <!-- <div style="flex:1;display:flex;flex-direction:row;justify-content:space-between;align-items:center;"> -->

        <div><b-button variant="light" style="background:transparent;border:none;color:transparent"><font-awesome-icon :icon="['far', 'times']"  /></b-button></div>

        <!-- <div /> -->
      </div>
    </template>
    <template v-slot:body>
      <!-- <h2>Notes</h2> -->
      <div class="bdy">
        <div v-if="lists === null">
          <em>No lists yet</em>
        </div>
        <div v-else-if="lists.length <= 0">
          <em>No lists yet</em>
        </div>
        <div v-else>
          <!-- <b-card v-for="(list, index) in lists" :key="list.id" :title="cardTitle(index)">
            
          </b-card> -->
            <div v-for="(list, index) in lists" :key="list.id" class="listMenuItem mb-3" @click="itemClicked(index)">
              <h4>{{ list.title }}</h4>
              <div>{{ displayDate(list.createdAt) }}</div>
            </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div style="width:100%;text-align:center">&copy; 2019 Cabinet Industries, LLC</div>
    </template>
  </slide-modal>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import moment from 'moment'
import SlideModal from "@/components/SlideModal"
import { EventBus } from '@/event-bus';
import { setTimeout } from 'timers';

function clean(obj) {
  for (var propName in obj) { 
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
      delete obj[propName];
    }
  }
}

export default {
  name: "Menu",
  components: {
    SlideModal
  },
  data() {
    return {
      note: {
        text: null,
        img: null
      }
    }
  },
  data() {
    return {
      // lists: []
      // lists: [
      //   {
      //     id: 'abc',
      //     title: "First",
      //   }, 
      //   {
      //     id: 'bcd',
      //     title: "Second"
      //   },
      //   {
      //     id: 'cde',
      //     title: "Third"
      //   }
      // ]
    }
  },
  computed: {
    ...mapFields([
      'lists'
    ]),
    ...mapGetters(['listsCount']),
    cleanedNote() {
      return clean(this.note)
    },
    cardTitle(index) {
      return "Title " + index
    }
  },
  methods: {
    emit (eventName) {
      return new Promise((resolve, reject) => {
        this.$emit(eventName)
        this.$nextTick(resolve)
      })
    },
    async itemClicked(index) {
      // console.log('[SideMenu] clicked: ', index)
      this.$emit('close-modal')
      // await this.emit('close-modal')
      setTimeout(() => {
        EventBus.$emit('switch-list', index);
      }, 100)
      
    },
    displayDate(isoDate) {
      let date = moment(isoDate)
      let now = moment()
      let hoursDiff = date.diff(now, 'hours')
      if (hoursDiff < 72) {
        return date.fromNow()
      } else {
        return date.format('LLLL')
      }
    },
  }
};
</script>

<style scoped>

.listMenuItem {
  border: 1px solid lightgray;
  border-radius:10px;
  padding: 20px;
  cursor: pointer;
}

.listMenuItem:hover {
  background: lightgray
}

.bdy {
  /* background: green; */
  /* height: 100%; */
  /* -webkit-overflow-scrolling: touch; */
}
</style>